import React, { Component } from 'react';
import moment from 'moment';

class RecipientDetails extends Component {
    _renderColumn = ({ title, content }) => { 
        return (
            <div className="flex-column">
                <div className="flex-title">{title}</div>
                <div className="flex-content">{content}</div>
            </div>
        );
    }
    render() {
        const { recipientId, recipientState: { recipientsById } } = this.props;
        const recipient = recipientsById[recipientId];
        let gender;
        switch (recipient.gender.toUpperCase()) {
            case 'F':
                gender = 'Female';
                break;
            case 'M':
                gender = 'Male';
                break;
            default:
                break; 
        }
        return (
            <div className="panel-details">
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Name', content: `${recipient.first_name} ${recipient.middle_name} ${recipient.last_name}` }) }
                    { this._renderColumn({ title: 'Gender', content: gender }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Date Of Birth', content: moment(recipient.dob).format('ddd, MMM Do, YYYY') }) }
                    { this._renderColumn({ title: 'Email', content: recipient.email }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Country Of School', content: recipient.country_of_school }) }
                    { this._renderColumn({ title: 'City Of School', content: recipient.city_of_school }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'MEF Enrollment Date', content: moment(recipient.mef_enrollment_date).format('ddd, MMM Do, YYYY') }) }
                    { this._renderColumn({ title: 'Adult Student', content: recipient.is_adult_student ? 'Yes' : 'No' }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Student Notes', content: recipient.notes }) }
                </div>
            </div>
        );
    }
}

export default RecipientDetails;


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/RecipientDetails.jsx